import LegalLayout from './LegalLayout'
import DocumentMeta from './DocumentMeta.jsx'

const LAST_UPDATED = '19 Φεβρουαρίου 2026'

function Terms() {
  return (
    <>
      <DocumentMeta
        title="Όροι Χρήσης | Πανελλήνιες+"
        description="Όροι και προϋποθέσεις χρήσης της πλατφόρμας Πανελλήνιες+, συμπεριλαμβανομένων διαφημίσεων και περιορισμού ευθύνης."
        canonical="https://www.panellhniesplus.gr/terms"
        robots="noindex, follow"
      />

      <LegalLayout title="Όροι Χρήσης">
        <p>
          Τελευταία ενημέρωση: <strong>{LAST_UPDATED}</strong>
        </p>
        <p>
          Με την πρόσβαση και χρήση του Panellhnies<sup>+</sup> αποδέχεστε τους παρακάτω όρους.
        </p>

        <h2>1. Χρήση περιεχομένου</h2>
        <p>
          Οι πληροφορίες (βάσεις, μόρια, θέματα, εργαλεία) παρέχονται για ενημερωτικούς σκοπούς και δεν
          υποκαθιστούν επίσημες ανακοινώσεις αρμόδιων αρχών.
        </p>

        <h2>2. Αποποίηση ευθύνης</h2>
        <p>
          Το Panellhnies<sup>+</sup> δεν αποτελεί επίσημο φορέα του Υπουργείου Παιδείας. Καταβάλλεται προσπάθεια
          ακρίβειας, αλλά δεν παρέχεται εγγύηση πληρότητας ή καταλληλότητας των πληροφοριών.
        </p>

        <h2>3. Διαφημίσεις και υπηρεσίες τρίτων</h2>
        <p>
          Ο ιστότοπος μπορεί να εμφανίζει διαφημίσεις μέσω Google AdSense. Η προβολή και εξατομίκευση διαφημίσεων
          εξαρτάται από τις επιλογές συγκατάθεσής σας και τις πολιτικές της Google.
        </p>

        <h2>4. Απαγορευμένη χρήση</h2>
        <p>
          Απαγορεύεται η αυτοματοποιημένη συλλογή δεδομένων, η κατάχρηση της υπηρεσίας, καθώς και οποιαδήποτε
          ενέργεια που παραβιάζει νόμους ή δικαιώματα τρίτων.
        </p>

        <h2>5. Πνευματικά δικαιώματα</h2>
        <p>
          Το περιεχόμενο και η δομή της πλατφόρμας προστατεύονται από δικαιώματα πνευματικής ιδιοκτησίας.
          Απαγορεύεται αναπαραγωγή ή εμπορική εκμετάλλευση χωρίς άδεια.
        </p>

        <h2>6. Τροποποιήσεις</h2>
        <p>
          Οι όροι ενδέχεται να τροποποιούνται. Η συνέχιση χρήσης του site μετά από αλλαγές συνεπάγεται αποδοχή
          των επικαιροποιημένων όρων.
        </p>
      </LegalLayout>
    </>
  )
}

export default Terms
